import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { I18n } from 'react-redux-i18n';
import BusdChart from '../../common/busd-chart/BUSDChart';
import { withComponentId } from '../../common/ComponentIdContext';
import { formatTextFloat } from '../../helpers/Text';
import { fetchBusd, REDUCER_NAME } from './reducer';

class TimeAndSaleBusd extends PureComponent {
  render() {
    const { busdData, width, condition, topContent } = this.props;
    const yAxisRightTickFormat = condition.isDerivatives
      ? d => formatTextFloat(d, 0)
      : undefined;

    return (
      <BusdChart
        priceData={{
          ...topContent,
          ceilingPrice: topContent.CeilingPrice,
        }}
        currentSearch={condition}
        yAxisRightTickFormat={yAxisRightTickFormat}
        title={I18n.t('timeAndSale.busdChartTitle')}
        data={busdData}
        width={width}
      />
    );
  }
}

const mapStateToProps = (state, { componentId }) => ({
  busdData: state[REDUCER_NAME].listMultiComponent[componentId].busdData,
  isFetching: state[REDUCER_NAME].listMultiComponent[componentId].isFetching,
  topContent: state[REDUCER_NAME].listMultiComponent[componentId].topContent,
  condition: state[REDUCER_NAME].listMultiComponent[componentId].condition,
  locale: state.i18n.locale,
});

const mapDispatchToProps = {
  fetchBusd,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TimeAndSaleBusd);
